"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function keyManager(actions, options) {
    const { prefix = '' } = options || {};
    const newActions = {};
    Object.keys(actions).forEach(key => {
        const keyValue = actions[key] ? actions[key] : key;
        newActions[key] = prefix + keyValue;
    });
    return newActions;
}
exports.default = keyManager;
